// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const STROLLER_MORE_QUESTIONS = "Dal\u0161\u00ed ot\u00e1zky";
export const STROLLER_QUESTIONS_AND_ANSWERS = "Ot\u00e1zky a odpov\u011bdi";
